import { createSelector } from 'reselect';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const defaultSelectors = createMetadataAPISelectors({ name: 'dutyExchanges' });

const openDutyExchanges = createSelector(defaultSelectors.values, dutyExchanges =>
  dutyExchanges.filter(exchange => exchange.state === 'open')
);

const openDutyExchangesByMembershipId = createSelector(openDutyExchanges, openDutyExchanges => {
  const result = {};
  openDutyExchanges.map(exchange => {
    result[exchange.membership_id] = result[exchange.membership_id] || [];
    result[exchange.membership_id] = [...result[exchange.membership_id], exchange];
  });
  return result;
});

export default {
  ...defaultSelectors,
  openDutyExchangesByMembershipId
};
